import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { Asset } from "../models/asset.model";

@Injectable()
export class AppService {
    public progress: string = "0";
    private asset : Asset = new Asset();
    private language = new BehaviorSubject<string>("");

    constructor() {}

    public setProgress(percantage: string) {
        this.progress = percantage;
    }

    public setAsset(asset: Asset){
        this.asset = asset;
    }

    public getAsset(){
        return this.asset;
    }

    public setLanguage(language: string){
        this.language.next(language);
    }

    public getLanguage(){
        return this.language.asObservable();
    }
    
}